import React, {
	FC, memo, useEffect, useState,
} from 'react';
import { filter, Subject, takeUntil } from 'rxjs';
import { Modal, Button } from '@sololearnorg/sol';
import { Container } from '../../../../../symphony';

import { SlActions } from '../../../services/ActionsService/sl-actions';
import {
	ActionType,
	ILockedCardModalData,
	RequestType,
} from '../../../global-interface';
import { SlLEContext } from '../../../global-constants';
import { SlDataService } from '../../../services/sl-data.service';

export const LockedCard: FC = memo(() => {
	const [modalData, setModalData] = useState<ILockedCardModalData>(null);

	useEffect(() => {
		const { lockedCardModalData$ } = Container.take(
			SlLEContext,
			SlDataService,
		);
		const unsubscriber = new Subject<void>();

		lockedCardModalData$
			.pipe(
				filter((m) => !!m),
				takeUntil(unsubscriber),
			)
			.subscribe(setModalData);

		return () => {
			unsubscriber.next();
			unsubscriber.complete();
		};
	}, []);

	const onContinueLearning = (): void => {
		const { actions$ } = Container.take(SlLEContext, SlActions);

		actions$.next({
			type: ActionType.OnLockedCardContinueClick,
			requestType: RequestType.Parallel,
		});
	};

	return modalData ? (
		<Modal.Default
			onClose={onContinueLearning}
			actions={[
				<Button
					buttonType="primary"
					onClick={onContinueLearning}
					key={1}
				>
					Ok
				</Button>,
			]}
			headline={modalData.headline}
			description={modalData.description}
		/>
	) : null;
});
